export const listPrices = `
   query listPrices($productId:ID!,$filter: PricesFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listPrices(productId: $productId, filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              productId
              product {
                id
                name
              }
              recurringOption
              priceStatus
              pricingModel
              amount
              ratePlanId
              description
              billingPeriod
              createdByUsername
              created
           }
           nextToken
       }
   }
`;

export const getPrice = `
   query getPrice($id:ID!) {
       getPrice(id:$id) {
         id
         productId
         product {
            id
            name
            billingProviderRecordId
         }
         recurringOption
         priceStatus
         pricingModel
         amount
         ratePlanId
         description
         billingPeriod
         stripePriceId
         createdByUsername
         createdByUser {
           name
           givenName
           familyName
           email
         }
         created
       } 
}`;
